import React, { useEffect, useState } from 'react'
import "./PillarVideosDetailsBanner.css"
import "./ResponsivePillarVideosDetailsBanner.css"
const host = process.env.REACT_APP_API_SERVER;
const PillarVideosDetailsBanner = ({ Banner }) => {
    const [fullUrl, setFullUrl] = useState(`${host}`);
    let [style, setStyle] = useState({ backgroundImage: "" });
    useEffect(() => {
        if (Banner) {
            console.log("Banner", Banner);
            let currentURL = Banner ? encodeURI(`${host}${Banner}`) : ""
            setFullUrl(currentURL);
            setStyle({ backgroundImage: `url(${currentURL})` })
        }
    }, [Banner])

    return (
        <>
            <section className='pillar-videos-details-banner-section' style={{backgroundImage:`url(${fullUrl})`}}>
                <div className="container-fluid">
                </div>
            </section>
        </>
    )
}

export default PillarVideosDetailsBanner